module.exports = __webpack_public_path__ + "static/media/o-que-preciso-para-alugar-mobile.eb914673.png";